import React from 'react'
import './style.css'
import { CaretRight, Files, GameController, GearSix, Headphones, House, Sidebar, SignOut, UserCircle, Video } from '@phosphor-icons/react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../utils/context'

export default function SideBar() {
    const location = useLocation()
    const { user } = useAuth()

    const onLogout = () => {
        localStorage.removeItem('xand_user')
        setTimeout(() => {
            window.location.reload()
        }, 1000);
    }

    if (location.pathname === '/' || location.pathname === '/games') {
        return (
            <div className={location?.pathname === '/projects' ? 'SideBar SideBar_Close' : 'SideBar'}>
                <div className='SideBar_Con'>
                    <div className='SideBar_Head'>
                        <Link to={'/'} className='Logo_Con'>
                            <h1>{location?.pathname === '/projects' ? "X" : "XAND"}</h1>
                        </Link>
                        <Sidebar className='SideBar_Head_Icon' color='#555' size={19} />
                    </div>
                    <Link to={'/'} className={location?.pathname === '/' ? 'SideBar_Item SideBar_Item_Active' : 'SideBar_Item'}>
                        <div className='SideBar_Item_Icon'>
                            <House size={19} weight='regular'/>
                        </div>
                        <p>Home</p>
                    </Link>
                    <Link to={'/games'} className={location?.pathname === '/games' ? 'SideBar_Item SideBar_Item_Active' : 'SideBar_Item'}>
                        <div className='SideBar_Item_Icon'>
                            <GameController size={19} weight='regular' />
                        </div>
                        <p>Games</p>
                    </Link>
                    <div className='SideBar_Item'>
                        <div className='SideBar_Item_Icon'>
                            <Files size={19} weight='regular' />
                        </div>
                        <p>Template</p>
                    </div>
                    <div className='SideBar_Item'>
                        <div className='SideBar_Item_Icon'>
                            <UserCircle size={19} weight='regular' />
                        </div>
                        <p>Profile</p>
                    </div>
                    <div className='FlexCon' />
                    <div className='SideBar_Item'>
                        <div className='SideBar_Item_Icon'>
                            <Video size={19} weight='regular' />
                        </div>
                        <p>Tutorial</p>
                    </div>
                    <div className='SideBar_Item1'>
                        <div className='SideBar_Item_Icon'>
                            <Headphones size={19} weight='regular' />
                        </div>
                        <p>Support</p>
                    </div>
                    <div className='Sidebar_Profile_Con'>
                        <img src={`https://api.dicebear.com/9.x/glass/svg?seed=${user?.name}`} />
                        <div className='Sidebar_Profile_Text'>
                            <h2>{user?.name}</h2>
                            <h3>Basic Plan</h3>
                        </div>
                        <div className='FlexCon' />
                        <SignOut onClick={()=>onLogout()} color='#555' size={15} weight='bold'/>
                    </div>
                </div>
            </div>
        )
    } else {
        return null
    }
}
